import React, { useEffect, useState } from 'react';
import styles from '../css/Exhibition.module.css';

import { Link, useHistory } from "react-router-dom";
import {GTranslate, InterpreterMode, NotificationImportant} from "@mui/icons-material";
import {Chip, Tab, Tabs, Tooltip} from "@mui/material";
import Box from "@mui/material/Box";
import Swal from "sweetalert2";
import Button from "components/inputs/Button";

import ExhibitionService from "service/apiConfig/ExhibitionService";
import { resetCreateExhibition } from "service/util/resetCreateExhibition";
import { useDispatch, useSelector } from "react-redux";
import { exhibitionActions } from "reducers/exhibition";
import { commonActions } from "reducers/common";
import ExhibitionDnd from "./ExhibitionDnd";
import IconButton from "@mui/material/IconButton";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            className={styles.exhTab}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const Exhibition = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [roomList, setRoomList] = useState([]);
    const invalidTrue = roomList.filter(room => room.invalid === true);
    const invalidFalse = roomList.filter(room => room.invalid === false);
    const type = useSelector(state => state.exhibitionData.type);
    const panelValue = useSelector(state => state.exhibitionData.panelValue);
    useEffect(() => {
        if (type === 'kor') {
            dispatch(exhibitionActions.setPanelValue(0));
            ExhibitionService.getAll(1)
                .then(response => {
                    setRoomList(response.data.data);
                    dispatch(commonActions.falseIsLoading());
                })
                .catch(err => console.log(err));

        } else if (type === 'eng') {
            dispatch(exhibitionActions.setPanelValue(1));
            ExhibitionService.getAll(2)
                .then(response => {
                    setRoomList(response.data.data);
                    dispatch(commonActions.falseIsLoading());
                })
                .catch(err => console.log(err));
        }
    }, [type, dispatch])

    const handlePanelChange = (event, newValue) => {
        dispatch(commonActions.trueIsLoading());
        dispatch(exhibitionActions.setPanelValue(newValue));
        if (panelValue === 0) {
            dispatch(exhibitionActions.setType('eng'));
        } else if (panelValue === 1) {
            dispatch(exhibitionActions.setType('kor'));
        }
    }

    const handleSeqIndex = () => {
        let seq = 0;
        roomList.forEach(room => {
            room.seq = seq++;
        })
        ExhibitionService.updateSeq(roomList)
            .then(response => {
                Swal.fire({
                    text: '저장이 완료되었습니다.',
                    icon: 'success',
                    confirmButtonText: '확인',
                }).then((result) => {
                    if (result.isConfirmed) {
                        history.push('/setting/exhibition');
                    } else return false;
                })
            })
            .catch(err => console.log(err));
    }

    const handleMoveCreate = () => {
        resetCreateExhibition(dispatch);
        history.push("/setting/create/exhibition");
    }

    const onDeleted = (id) => {
        Swal.fire({
            title: '정말 삭제하시겠습니까 ?',
            icon: 'warning',
            confirmButtonText: '네',
            cancelButtonText: '아니오',
            showCancelButton: true,
            confirmButtonColor: '#D55240',
        }).then(result => {
            if (result.isConfirmed) {
                ExhibitionService.deleted(id)
                    .then(response => {
                        const list = roomList.filter(item => item.id !== id);
                        setRoomList(list);
                        return true;
                    })
                    .catch(err => console.log(err));
            }
        });
    }

    return (
        <section className={`sectionWrap ${styles.exhibitionWrap}`}>
            <header>
                <h2>전시 관리</h2>
                <Button onClick={handleMoveCreate} style={{ background: "#A2B521" }}>등록</Button>
            </header>
            <Box
                sx={{ display: 'flex', border: '1px solid #f1f3f4', py: '1rem' }}
            >
                <Tabs
                    orientation="vertical"
                    value={panelValue}
                    onChange={handlePanelChange}
                    aria-label="Vertical tabs example"
                    sx={{ borderRight: 1, borderColor: 'divider', fontSize: '14px' }}
                >
                    <Tab
                        icon={<InterpreterMode className={`${styles.tabLabelSvg} ${panelValue === 0 ? styles.active : ''}`} />}
                        label={<span className={`${styles.tabLabel} ${panelValue === 0 ? styles.active : ''}`}>일반<br/> 어린이 <br/> 시각장애인</span>}
                        {...a11yProps(0)}
                    />
                    <Tab
                        icon={<GTranslate className={`${styles.tabLabelSvg} ${panelValue === 1 ? styles.active : ''}`} />}
                        label={<span className={`${styles.tabLabel} ${panelValue === 1 ? styles.active : ''}`}>영문</span>}
                        {...a11yProps(1)}
                    />
                </Tabs>
                <TabPanel value={panelValue} index={panelValue === 0 ? 0 : 1}>
                    <div className={styles.seqNotice}>
                        <div>
                            <Chip label="노출 중 전시관" sx={{ marginLeft: "1rem" }} />
                            <Tooltip className={"tooltip"} placement="top" title={"드래그 앤 드랍으로 정렬 순서를 바꾼 후\n저장 버튼을 클릭해주세요."}>
                                <IconButton>
                                    <NotificationImportant sx={{ color: "#5a54a1" }} />
                                </IconButton>
                            </Tooltip>
                        </div>
                        <Button className={styles.seqSubmitBtn} onClick={handleSeqIndex} type={"button"}>저장</Button>
                    </div>
                    <ul className={`${styles.exhList} ${invalidFalse.length < 3 ? styles.caption : ""}`}>
                        {invalidFalse.length === 0 &&  <p className={"noData"}>데이터가 없습니다. 등록해주세요.</p>}
                        <ExhibitionDnd
                            invalidFalse={invalidFalse}
                            roomList={roomList}
                            setRoomList={setRoomList}
                            onDeleted={onDeleted}
                        />
                    </ul>
                    {invalidFalse.length < 3 && <div className={styles.exhCaption}>3개 전시관이 노출되어야 정상 서비스 가능합니다.</div>}
                    <Chip label="미노출 전시관" sx={{ marginLeft: "1rem" }} />
                    <ul className={styles.exhList}>
                        {invalidTrue.length === 0 &&  <p className={"noData"}>데이터가 없습니다. 등록해주세요.</p>}
                        {invalidTrue.map((room, i) => (
                            <li key={room.id}>
                                <input type={"hidden"} value={room.id} />
                                <span>[ <b>{i + 1}</b> ]</span>
                                <div className={styles.exhImg}>
                                    <img alt={room.imageAltText} src={room.imageUrl} />
                                </div>
                                <div className={styles.exhRoomInfo}>
                                    <h5 className={"ellipsis1"} style={{ width: "100%" }}>{room.roomNo}</h5>
                                    <h4 className={"ellipsis1"} style={{ width: "100%" }}>{room.name}</h4>
                                    <span className={"ellipsis3"} style={{ width: "100%", wordWrap: "break-word", wordBreak : "break-all" }}>{room.introduction}</span>
                                </div>
                                <Link to={`/setting/exhibition/${room.id}`}>
                                    <Button style={{ background: "#DFA78F" }}>
                                        수정
                                    </Button>
                                </Link>
                                <Button onClick={() => onDeleted(room.id)} style={{ background: "#D55240" }}>삭제</Button>
                            </li>
                        ))}
                    </ul>
                </TabPanel>
            </Box>
        </section>
    );
};

export default Exhibition;